export default "__VITE_ASSET__DyGmla4X__"